import { Box, Stack, TextField, Typography, useTheme } from '@mui/material';

type NumberFieldProps = {
  label: string;
  value: number | null;
  onChange: (value: number | null) => void;
  disabled?: boolean;
};

export default function FormFieldQuantity({ label, value, onChange, disabled = false }: NumberFieldProps) {
  const theme = useTheme();

  return (
    <Box sx={{ mb: 2, mt: 2 }}>
      <Stack direction="row" alignItems="center" spacing={2} sx={{ width: '50%', display: 'flex' }}>
        <Typography variant="fieldHeader" width={theme.spacing(15)}>
          {label}
        </Typography>
        <TextField
          type="number"
          sx={{
            flexGrow: 1,
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
            },
            width: '20%',
          }}
          size="small"
          value={value ?? ''}
          onChange={(e) => {
            const parsed = Number(e.target.value);
            onChange(Number.isNaN(parsed) ? null : parsed);
          }}
          disabled={disabled}
        />
      </Stack>
    </Box>
  );
}
